<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="supplierdatalog"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			currentrow: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '盒箱规修改记录',
				modal_width:1000,
				modal_height:500,
				list_formConfig: [{
					field: 'goodscode',
					title: '产品编码',
					itemRender: {
						name: '$input'
					}
				}],
				list_footerField:[
					{field:'needamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						field: 'goodscode',
						title: '产品编码',
					},{
						field: 'newboxgauge',
						title: '盒规',
					},
					{
						field: 'newbingauge',
						title: '箱规'
					},
					{
						field: 'boxgauge',
						title: '往期盒规',
					},
					{
						field: 'bingauge',
						title: '往期箱规'
					},
					{
						field: 'action',
						title: '操作类型'
					},
					{
						field: 'staffid',
						title: '操作人',
						formatter:({cellValue})=>{
							return window.systemMethods.getstaff(cellValue)
						}
					},
					{
						field: 'create_time',
						title: '操作时间',
						width:150,
						formatter:({cellValue})=>{
							return this.$Moment.unix(cellValue).format('YYYY-MM-DD HH:mm:ss')
						}
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						slots: {
							default:({row})=>{
								return	[
										<el-button size="mini" type="text" style="color:#F56C6C;" onClick={()=>{this.retract(row)}}>回撤</el-button>,
									]
							}
						}
					},
				]
				gridOptions.pagerConfig.enabled = true
			},
			retract(row){
				this.$confirm('是否确认回撤').then(()=>{
					this.$api.supplier.updateboxgauge({data:[row]}).then(()=>{
						this.$refs.supplierdatalog.commitProxy('query')
					})
				})
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.supplier.listboxgauge({
						supplierid:this.currentrow?this.currentrow.id:null,
						...page,
						...updateForm,
						...other,
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						resolve([])
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>